import { navigate, useLocation } from '@reach/router'
import useRolePermission from '_/hooks/use-role-permission'
import { useToast } from '_/hooks/use-toast'
import { getAgencyFull } from '_/modules/agency/actions'
import { userSelector } from '_/modules/authentication/selectors'
import { menuItemsSelector } from '_/modules/menu-items/selector'
import { ROUTES } from '_/utils/constants'
import React, { useMemo, useEffect, useState } from 'react'
import { Loader } from '@refera/ui-web'
import { useDispatch, useSelector } from 'react-redux'

function DashboardReport() {
  const dispatch = useDispatch()
  const userToken = useSelector(x => x.user.get('authToken'))
  const { pathname } = useLocation()
  const { checkPathPermission } = useRolePermission()
  const { showToast } = useToast()
  const userMenuItems = useSelector(menuItemsSelector)
  const user = useSelector(userSelector)

  const [reportUrl, setReportUrl] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  async function loadDataAndReportUrls() {
    setIsLoading(true)
    let dataUrl = ''
    const activeProfile = user?.activeProfile || user?.get('activeProfile')
    if (!activeProfile?.areaOfActivityDefined) {
      if (!activeProfile?.urlPainel) {
        showToast({ type: 'error', message: 'URL não definida. Favor contatar o suporte.' })
        setIsLoading(false)
        return
      }
      dataUrl = activeProfile.urlPainel
    } else {
      const agencyId = user?.get('agency')
      if (!agencyId) {
        showToast({
          type: 'error',
          message: 'Usuário não vinculado a uma intermediária. Favor contatar o suporte.',
        })
        setIsLoading(false)
        return
      }

      try {
        const data = await dispatch(getAgencyFull(agencyId))
        if (!data?.areaOfActivity?.name) {
          showToast({
            type: 'error',
            message: 'Intermediária não vinculada a uma área de atuação. Favor contatar o suporte.',
          })
          setIsLoading(false)
          return
        }

        const urlPainel = data?.areaOfActivity?.panelUrl

        if (!urlPainel) {
          showToast({
            type: 'error',
            message: 'URL não definida. Favor contatar o suporte.',
          })

          setIsLoading(false)

          return
        }

        dataUrl = urlPainel
      } catch {
        showToast({ type: 'error', message: 'Erro ao buscar dados da intermediária.' })
        setIsLoading(false)
        return
      }
    }

    if (dataUrl) {
      const urlWithParams = `${dataUrl}?params=${encodeURIComponent(
        JSON.stringify({ token: userToken })
      )}`
      setReportUrl(urlWithParams)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    loadDataAndReportUrls()
  }, [user])

  useEffect(() => {
    if (pathname && userMenuItems.length > 0) {
      if (!checkPathPermission(pathname)) {
        showToast({
          type: 'error',
          message:
            'Você não tem permissão para visualizar os dados desta área da aplicação. Por favor, fale com seu administrador.',
        })
        navigate(ROUTES.WIDGETS)
      }
    }
  }, [pathname, checkPathPermission])

  const renderContent = useMemo(() => {
    const url = reportUrl
    return (
      <div
        style={{
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          height: '100vh',
          width: '100%',
          position: 'relative',
        }}
      >
        <iframe
          title="Relatório do Dashboard"
          width="100%"
          height="100%"
          src={url}
          frameBorder="0"
          style={{
            border: 0,
            width: '100%',
            height: '100%',
          }}
          allowFullScreen
        />
      </div>
    )
  }, [reportUrl])

  if (isLoading) {
    return (
      <div>
        <Loader hasBackdrop open={isLoading} label="Aguarde..." />
      </div>
    )
  }

  return <div>{renderContent}</div>
}

export default DashboardReport
